<template>
  <section id="preview-experience" class="page-section preview-experience-section">
    <PreviewExperience />
  </section>
</template>

<script setup lang="ts">
import PreviewExperience from '@/components/PreviewExperience.vue'
</script>

<style scoped>
.preview-experience-section {
  width: 100%;
  display: none;
}
</style>
